/**
 * Lib-internal actions for `shared/classroom/preview-screen/feature-shell`.
 *
 * These actions are NOT exported from any barrel. They are internal
 * remappers — UI components dispatch them, `active-element.effects.ts`
 * listens and translates to a state-changing call on
 * `ClassroomFacade.showSlideOnLayer`. Stage D.2 of the write-path
 * architecture refactor moved them out of the public
 * `InternalClassroomActions` / `ActiveElementUserInteractionActions`
 * namespaces (in `shared/classroom/preview-screen/core`) because the
 * Q1 audit flagged them as DOMAIN-INTERNAL (one dispatcher → one
 * listener, both inside this lib).
 */

import { createAction } from '@ngrx/store';

export const showPreviousBookpageLinkHasBeenClicked = createAction(
    '[Active Element User] Has clicked previous bookpage',
);

export const showNextBookpageLinkHasBeenClicked = createAction(
    '[Active Element User] Has clicked next bookpage',
);
